import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { map, mergeMap, Observable, of} from "rxjs";

import packageJson from "../../../../package.json";

import {AuthenticateUserRequest} from '@commons/models/remote.request/AuthenticateUserRequest';
import {AuthenticateUserResponse} from '@commons/models/remote.response/AuthenticateUserResponse';
import {WebResponse} from "@commons/models/remote.response/WebResponse";

import {BaseHttpService} from "@shared/services-http/base-http.service";
import {AuthenticateByTokenRequest} from "@shared/services-http/requests/authenticateByTokenRequest";
import { RemoteDataService } from '@commons/services/remote.data/remote-data.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationHttpService extends BaseHttpService {

  readonly version: string = packageJson.version;

  constructor(
    private httpClient: HttpClient,
    private $service: RemoteDataService,
  ) {
    super();
  }
  authenticateUser(request: AuthenticateUserRequest): Observable<AuthenticateUserResponse> {
    request.Platform = 'web';
    request.applicationAndVersion = 'mycar.tekom.pl ' + this.version;
  
    const headers = new HttpHeaders({
      ClientName: request.DB || '',
    });

    return this.httpClient.post<AuthenticateUserResponse>(this.getAuthUrl('/AuthenticateUser'), request, { headers }).pipe(
      mergeMap((authResponse) => {
        if (request.DB) {
          return this.AddUserLog().pipe(
            map(() => authResponse)
          );
        }
        return of(authResponse);
      })
    );
  }
  
  public AddUserLog(): Observable<WebResponse> {
    const url = environment.hammerApiUrl + `/AddUserLog`;
    return this.$service.httpPost(url, {}); 
  }

  authenticateByToken(token: string): Observable<AuthenticateUserResponse> {
    const request = {} as AuthenticateByTokenRequest;
    request.token = token;
    request.platform = 'web';
    request.applicationAndVersion = 'mycar.tekom.pl ' + this.version;
    return this.httpClient.post<any>(this.getAuthUrl('/AuthenticateByToken'), request);
  }

  closeUserSession(sessionId: string): Observable<WebResponse> {
    const headers = {headers: new HttpHeaders({sessionId: sessionId})};
    return this.httpClient.post<WebResponse>(this.getAuthUrl('/RemoveSession'), {}, headers);
  }

  keepSession(): Observable<WebResponse> {
    return this.httpClient.post<WebResponse>(this.getUrl('/KeepSession'), {});
  }

}
